import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { Button } from '@module/mdrt-org/shared/components/button/button';
import { CloseIcon } from '@shared/ui-components/svgs';
import { type SearchCmsContent } from '../../../../graphql/get-search-cms-content';
import styles from './filter-header.module.scss';
type FilterHeaderProps = {
  className?: string;
  onClose: () => void;
  searchCmsContent: SearchCmsContent;
};
export const FilterHeader = t0 => {
  const $ = _c(11);
  const {
    className,
    onClose,
    searchCmsContent
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classnames(styles["filter-header"], className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = searchCmsContent.searchPage?.FiltersLabel || "Filters";
  let t3;
  if ($[2] !== t2) {
    t3 = <h2 className={styles["filter-header__text"]}>{t2}</h2>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClose || $[5] !== searchCmsContent.generic.close) {
    t4 = <Button aria-label={searchCmsContent.generic.close} className={styles["filter-header__close-button"]} Icon={CloseIcon} onClick={onClose} />;
    $[4] = onClose;
    $[5] = searchCmsContent.generic.close;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t3 || $[9] !== t4) {
    t5 = <header className={t1}>{t3}{t4}</header>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};